import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconV2ArchiveOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="1em" height="1em"><path d="M28 9.993V6L4 6.057v3.936zM30 4v8h-3v12h-2V12H7v14h20l-1.212 2H5V12H2V4zM20 16h-8v2h8z" /></svg>
);
